import { Typography } from "@mui/material";
import React from "react";
import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
// react dropzone
import ReactDropzone from "react-dropzone";
import { connect, useDispatch, useSelector } from "react-redux";
import { getGiftCategory } from "../../../store/GiftCategory/GiftCategory.action";
import { createGift } from "../../../store/Gift/gift.action";
import { useEffect } from "react";
import { setToast } from "../../../util/toast";



const AddGift = (props) => {
  const { giftCategory } = useSelector((state) => state.giftCategory);
  
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getGiftCategory());
  }, [dispatch]);

  

  const [coin, setCoin] = useState("");
  const [adlar, setAdlar] = useState({ name: "", name_ar: "", name_en: "" });
  const [category, setCategory] = useState("");
  const [images, setImages] = useState([]);
  const [svga, setSvga] = useState(null);
  const [errors, setError] = useState({
    image: "",
    coin: "",
    category: "",
  });

  const GiftClick = sessionStorage.getItem("giftClick");
  const categoryDetail = JSON.parse(sessionStorage.getItem("category"));

  const history = useHistory();
  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !coin ||
      coin < 0 ||
      (GiftClick !== null && (category === "Select Category" || !category)) ||
      images.length === 0 ||
      false
    ) {
      const errors = {};

      if (!coin) errors.coin = "Coin is Required!";
      if (coin < 0) errors.coin = "Invalid Coin!";


      if (images.length === 0) errors.image = "Please select an Image!";

      if (GiftClick !== null && (category === "Select Category" || !category)) {
        errors.category = "Please select a Category!";
      }
      return setError({ ...errors });
    }

    const coinValid = isNumeric(coin);
    if (!coinValid) {
      return setError({ ...errors, coin: "Invalid Coin!" });
    }
    const formData = new FormData();

    formData.append("category", category ? category : categoryDetail?._id);
    formData.append("coin", coin);
    Object.entries(adlar).forEach(([k, v]) => formData.append(k, v || ""));
    // Hediyeler platforma gore ayrilmaz; alan geriye donuk uyum icin 0 gider.
    formData.append("platFormType", 0);
    for (let i = 0; i < images.length; i++) {
      formData.append("imageVideo", images[i]);
    }
    if (svga) formData.append("svga", svga);
     
    
    props.createGift(formData);

    setTimeout(() => {
      GiftClick === null && history.push("/admin/giftCategory/gift");
    }, 3000);
  };
  const onPreviewDrop = (files) => {
    setError({ ...errors, image: "" });
    files.map((file) =>
      Object.assign(file, { preview: URL.createObjectURL(file) })
    );
    setImages(images.concat(files));
  };

  const removeImage = (file) => {
    if (file.preview) {
      const image = images.filter((ele) => {
        return ele.preview !== file.preview;
      });
      setImages(image);
    }
  };
  const isNumeric = (value) => {
    const val = value === "" ? 0 : value;
    const validNumber = /^\d+$/.test(val);
    return validNumber;
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };
  return (
    <>
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-body card-overflow">
              <div class="d-sm-flex align-items-center justify-content-between mb-4"></div>

              <form>
                {/* hediye adi: 3 dil (uygulamada kullanicinin diline gore gorunur) */}
                <div className="row">
                  {[["name", "Ad · Türkçe", "Gül"], ["name_ar", "Ad · Arapça", "وردة"], ["name_en", "Ad · İngilizce", "Rose"]].map(([k, ad, ph]) => (
                    <div className="col-md-4" key={k}>
                      <div className="form-group">
                        <label className="float-left dialog__input__title">{ad}</label>
                        <input
                          className="form-control"
                          maxLength={40}
                          dir={k === "name_ar" ? "rtl" : "ltr"}
                          placeholder={ph}
                          value={adlar[k] || ""}
                          onChange={(e) => setAdlar({ ...adlar, [k]: e.target.value })}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label class="float-left dialog__input__title">
                        Coin
                      </label>
                      <input
                        type="number"
                        className="form-control pe-1"
                        required=""
                        placeholder="20"
                        value={coin}
                        onChange={(e) => {
                          setCoin(e.target.value);
                          if (!e.target.value) {
                            return setError({
                              ...errors,
                              coin: "Coin is Required!",
                            });
                          } else {
                            return setError({
                              ...errors,
                              coin: "",
                            });
                          }
                        }}
                        onKeyPress={handleKeyPress}
                      />
                      {errors.coin && (
                        <div className="ml-2 mt-1">
                          {errors.coin && (
                            <div className="pl-1 text__left">
                              <span className="text-danger">{errors.coin}</span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label class="float-left dialog__input__title">
                        Kategori
                      </label>
                      {GiftClick === null ? (
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Kategori adı"
                          value={categoryDetail?.name}
                        />
                      ) : (
                        <>
                          <select
                            class="form-select form-control"
                            aria-label="Seçim"
                            value={category}
                            onChange={(e) => {
                              setCategory(e.target.value);
                              if (e.target.value === "Select Category") {
                                return setError({
                                  ...errors,
                                  category: "Please select a Category!",
                                });
                              } else {
                                return setError({
                                  ...errors,
                                  category: "",
                                });
                              }
                            }}
                          >
                            <option value="Select Category" selected>
                              Select Category
                            </option>
                            {giftCategory.map((category) => {
                              return (
                                <>
                                  <option
                                    className="text-capitalize"
                                    value={category._id}
                                  >
                                    {category?.name}
                                  </option>
                                </>
                              );
                            })}
                          </select>
                          {errors.category && (
                            <div className="ml-2 mt-1">
                              {errors.category && (
                                <div className="pl-1 text__left">
                                  <span className="text-danger">
                                    {errors.category}
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row my-2">
                <div className="col-12 my-2">
                  <label className="mb-2 dialog__input__title">Tam ekran animasyon (SVGA, isteğe bağlı)</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => {
                      // accept=".svga" macOS'ta dosyayi secilemez yapiyordu; kontrol burada
                      const f = e.target.files?.[0] || null;
                      if (f && !/\.svga$/i.test(f.name)) {
                        setToast("error", "Yalnızca .svga dosyası yükleyebilirsin");
                        e.target.value = "";
                        return setSvga(null);
                      }
                      setSvga(f);
                    }}
                  />
                  <small style={{ color: "#64748B" }}>Hediye gönderilince ekranda oynar. Ekrana sığacak şekilde gösterilir.</small>
                </div>
                </div>
                <div className="row my-4">
                  <div className="col-12 ">
                    <label class="float-left dialog__input__title ">
                      Select (Multiple) Image or GIF
                    </label>

                    <>
                      <ReactDropzone
                        onDrop={(acceptedFiles) => onPreviewDrop(acceptedFiles)}
                        accept="image/*"
                      >
                        {({ getRootProps, getInputProps }) => (
                          <section className="mt-4">
                            <div {...getRootProps()}>
                              <input {...getInputProps()} />
                              <div
                                style={{
                                  height: 130,
                                  width: 130,
                                  border: "2px dashed gray",
                                  textAlign: "center",
                                  marginTop: "10px",
                                }}
                              >
                                <i
                                  className="fas fa-plus"
                                  style={{ paddingTop: 22, fontSize: 70 }}
                                ></i>
                              </div>
                            </div>
                          </section>
                        )}
                      </ReactDropzone>

                      {errors.image && (
                        <div className="ml-2 mt-1">
                          {errors.image && (
                            <div className="pl-1 text__left">
                              <span className="text-danger">
                                {errors.image}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  </div>
                  <div className="col-lg-6 mt-4">
                    {images.length > 0 && (
                      <>
                        {images.map((file, index) => {
                          return (
                            file.type?.split("image")[0] === "" && (
                              <>
                                <img
                                  height="60px"
                                  width="60px"
                                  alt="app"
                                  src={file.preview}
                                  style={{
                                    boxShadow:
                                      "0 5px 15px 0 rgb(105 103 103 / 00%)",
                                    border: "2px solid #fff",
                                    borderRadius: 10,
                                    marginTop: 10,
                                    float: "left",
                                    objectFit: "contain",
                                    marginRight: 15,
                                  }}
                                  draggable="false"
                                />
                                <div
                                  class="img-container"
                                  style={{
                                    display: "inline",
                                    position: "relative",
                                    float: "left",
                                  }}
                                >
                                  <i
                                    class="fas fa-times-circle text-danger"
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "4px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => removeImage(file)}
                                  ></i>
                                </div>
                              </>
                            )
                          );
                        })}
                      </>
                    )}
                  </div>
                </div>

                <div className="mt-5 d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn  btn-success my-3 mx-2"
                    onClick={handleSubmit}
                  >
                    Ekle
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-danger my-3 "
                    onClick={() => {
                      GiftClick === null
                        ? history.push("/admin/giftCategory/gift")
                        : history.push("/admin/gift");
                    }}
                  >
                    Kapat
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { createGift, getGiftCategory })(AddGift);
